import axios from "axios";

export default axios.create({
  baseURL: "https://contacts-manager-backend-rhke.onrender.com",
});
